const CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 ore in millisecondi

// const CACHE_DURATION = 5*1000; // 12 ore in millisecondi

export const getCachedData = (key) => {
  try {
    const cached = localStorage.getItem(key);
    if (!cached) return null;
    
    const { data, timestamp } = JSON.parse(cached);
    const now = Date.now();
    
    // Verifica se la cache è ancora valida (meno di 12 ore)
    if (now - timestamp < CACHE_DURATION) {
      return data;
    }
    
    // Cache scaduta, rimuovi
    localStorage.removeItem(key);
    return null;
  } catch (error) {
    console.error('Errore nel recupero della cache:', error);
    return null;
  }
};

export const setCachedData = (key, data) => {
  try {
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
  } catch (error) {
    console.error('Errore nel salvataggio della cache:', error);
  }
};

export const CACHE_KEYS = {
  HOME_STAT: 'home_stat_cache',
  STATS_V3: 'stats_v3_cache',
};

export const getHomeStatCacheKey = (salonId) =>
  salonId ? `${CACHE_KEYS.HOME_STAT}_${salonId}` : CACHE_KEYS.HOME_STAT;

export const getStatsCacheKey = (section, salonId, query = '') =>
  `${CACHE_KEYS.STATS_V3}_${section}_${salonId || 'x'}_${query || 'default'}`;

/** Invalida la cache v3 di un salone (dopo unlock password: evita zeri stale). */
export const clearStatsV3CacheForSalon = (salonId) => {
  if (salonId == null || salonId === '') return;
  const prefix = `${CACHE_KEYS.STATS_V3}_`;
  const idNeedle = `_${salonId}_`;
  try {
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix) && key.includes(idNeedle)) {
        toRemove.push(key);
      }
    }
    toRemove.forEach((key) => localStorage.removeItem(key));
  } catch (_) {
    /* ignore */
  }
};

export const clearHomeStatCache = () => {
  localStorage.removeItem(CACHE_KEYS.HOME_STAT);
  localStorage.removeItem('statSalone');

  try {
    const salons = JSON.parse(localStorage.getItem('salons') || '[]');
    salons.forEach((salon) => {
      if (salon?.idsalone) {
        localStorage.removeItem(getHomeStatCacheKey(salon.idsalone));
      }
    });
  } catch (error) {
    console.error('Errore nella pulizia cache home stat:', error);
  }
};